__turbopack_context__.v({
  "container": "FullWidthCarousel-module-scss-module__9XsSha__container",
  "heroCarouselNavSlider": "FullWidthCarousel-module-scss-module__9XsSha__heroCarouselNavSlider",
  "mainHeroCarousel": "FullWidthCarousel-module-scss-module__9XsSha__mainHeroCarousel",
  "sliderContainer": "FullWidthCarousel-module-scss-module__9XsSha__sliderContainer",
  "smallOverlay": "FullWidthCarousel-module-scss-module__9XsSha__smallOverlay",
});
